import React from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import SourcePicker from "./SourcePicker";

const CreateSearchModal = ({ isOpen, onClose, buId, onCreated }) => {
  const { t } = useTranslation("portal");

  const handleCreated = (newId) => {
    onCreated?.(newId);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent data-testid="create-search-modal">
        <ModalHeader sx={{ marginBottom: "0 !important" }}>
          {t("asapProfile.create.title")}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <SourcePicker buId={buId} onCreated={handleCreated} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CreateSearchModal;
